class FooterMenu {
  constructor() {
    this.init();
  }

  init() {
    this.menuItems = document.querySelectorAll('[data-menu-item]');

    if (!this.menuItems.length) return;

    this.menuItems.forEach(item => {
      const toggle = item.querySelector('.footer__menu-toggle');

      if (!toggle) return;

      toggle.addEventListener('click', () => this.toggleMenu(item));
    });
  }

  toggleMenu(item) {
    const isActive = item.classList.contains('is-active');
    const toggle = item.querySelector('.footer__menu-toggle');

    if (isActive) {
      item.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('is-active');
      toggle.setAttribute('aria-expanded', 'true');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FooterMenu();
  });
} else {
  new FooterMenu();
}
